/// <reference path="./barcode.d.ts" />
import { PageGen } from '../pdf';
import { PdfBrush, PdfRect, PdfPoint, PdfPen } from '../pdf';
// @ts-ignore - Type definitions don't match runtime
import qrcodegen from 'nayuki-qr-code-generator';

PageGen.prototype.drawQr = function (rect: PdfRect, brush: PdfBrush, text: string): void {
  // Use Nayuki's qrcodegen to generate a proper QR code matrix
  // Use error correction level M and no border (we'll draw exact modules into rect)
  // Handle both namespace and default export structures
  // @ts-ignore - Runtime may have different structure
  const QrCode = (qrcodegen as any).QrCode || (qrcodegen as any).default?.QrCode;
  if (!QrCode) {
    throw new Error('QR Code generator not found in nayuki-qr-code-generator module');
  }
  const qr = QrCode.encodeText(text, QrCode.Ecc.MEDIUM);
  const {size} = qr; // size is a property, not a method
  const bits: boolean[][] = [];
  for (let y = 0; y < size; y++) {
    bits[y] = [];
    for (let x = 0; x < size; x++) {
      bits[y][x] = qr.getModule(x, y);
    }
  }

  this.drawDataMatrix(rect, brush, bits);
};

PageGen.prototype.drawDataMatrix = function (
  rect: PdfRect,
  brush: PdfBrush,
  bits: boolean[][]
): void {
  if (!bits || bits.length === 0) return;
  const rows = bits.length;
  const cols = bits[0].length;

  const cellW = rect.width / cols;
  const cellH = rect.height / rows;

  for (let x = 0; x < cols; x++) {
    for (let y = 0; y < rows; y++) {
      if (!bits[y][x]) continue;
      // try to collapse consecutive vertical runs into one rectangle like the C# QR implementation
      let runY = y + 1;
      while (runY < rows && bits[runY][x]) runY++;
      const drawRect = new PdfRect(
        rect.left + x * cellW,
        rect.top + y * cellH,
        cellW,
        cellH * (runY - y)
      );
      this.drawRectangle(null, brush, drawRect);
      y = runY - 1;
    }
  }
};

PageGen.prototype.drawArBarcode = function (
  rect: PdfRect,
  brush: PdfBrush,
  barcode = 0
): void {
  const cellW = rect.width / 6;
  const cellH = rect.height / 6;

  const patterns: boolean[][][] = [
    [
      [false, true, true],
      [true, true, true],
      [false, true, true],
    ],
    [
      [false, true, true],
      [true, true, true],
      [false, false, true],
    ],
    [
      [false, true, true],
      [true, false, true],
      [false, true, true],
    ],
    [
      [false, true, true],
      [true, false, true],
      [false, false, true],
    ],
  ];
  const pattern = patterns[barcode % 4];

  this.drawRectangle(null, brush, rect);

  for (let x = 0; x < 3; x++) {
    for (let y = 0; y < 3; y++) {
      if (pattern[y][x]) {
        const r = new PdfRect(rect.x + cellW * (1.5 + x), rect.y + cellH * (1.5 + y), cellW, cellH);
        this.drawRectangle(null, PdfBrush.White, r);
      }
    }
  }
};
